export default __webpack_public_path__ + "static/1-a147d27042cc67401e2e836a6e6933ca.mp4";